import { combineReducers } from 'redux';
import { hasIn } from 'lodash';

import {
  GET_DEFAULT_RECOMMENDATIONS_SUCCESS,
  GET_FILTERED_RECOMMENDATIONS_SUCCESS,
  GET_MORE_RECOMMENDATIONS_SUCCESS,
  REMOVE_RECOMMENDATION_FROM_LIST,
} from 'actionTypes';

function allIdsReducer(state = [], action) {
  const { type, normalizedData } = action;
  switch (type) {
    case GET_DEFAULT_RECOMMENDATIONS_SUCCESS:
    case GET_FILTERED_RECOMMENDATIONS_SUCCESS:
      return normalizedData.result;
    case GET_MORE_RECOMMENDATIONS_SUCCESS:
      return state.concat(normalizedData.result);
    case REMOVE_RECOMMENDATION_FROM_LIST:
      const ids = [...state];
      return ids.filter(id => id !== action.uuid);
    default:
      return state;
  }
}

function byIdReducer(state = {}, action) {
  if (action.type === REMOVE_RECOMMENDATION_FROM_LIST) {
    const ids = { ...state };
    delete ids[action.uuid];
    return ids;
  } else if (hasIn(action, ['normalizedData', 'entities', 'recommendations'])) {
    return {
      ...state,
      ...action.normalizedData.entities.recommendations,
    };
  } else {
    return state;
  }
}

export default combineReducers({
  byId: byIdReducer,
  allIds: allIdsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/recommendationsReducer.js